const mycode = "suvaduley20191011#11";
export default mycode;
